module.exports = __webpack_public_path__ + "static/media/mobile-7-2.1fcb9a67.gif";